<template>
  <div class="flex flex-row flex-wrap">
    <Field name="requestNumber" v-slot="{ field, errors: errs }">
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('requestNumber')"
        :maxLength="10"
        direction="flex-col"
        :isRequired="false"
        class="lg:w-1/2 flex-col px-2 w-full"
      />
    </Field>

    <Field
      :rules="validateEmail"
      :name="props.roleType === 'establishment' ? 'ownerEmail' : 'email'"
      v-slot="{ field, errors: errs }"
      class="w-full"
    >
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('email')"
        class="lg:w-1/2 flex-col px-2 w-full"
        direction="flex-col"
        :isRequired="false"
      />
    </Field>

    <Field
      v-if="props.roleType == 'establishment'"
      name="applicantName"
      v-slot="{ field, errors: errs }"
      class="w-full"
    >
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('applicantName')"
        class="lg:w-1/2 flex-col px-2 w-full"
        direction="flex-col"
        :isRequired="false"
        :maxLength="120"
      />
    </Field>

    <Field
      :name="props.roleType === 'establishment' ? 'ownerName' : 'serviceBeneficiaryname'"
      v-slot="{ field, errors: errs }"
    >
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('serviceBeneficiaryname')"
        :maxLength="10"
        direction="flex-col"
        :isRequired="false"
        class="lg:w-1/2 flex-col px-2 w-full"
      />
    </Field>

    <Field
      name="mobileNumber"
      v-slot="{ field, errors: errs, handleChange }"
      class="w-full"
      v-if="countries.length"
    >
      <ComboText
        :field="field"
        :errors="errs"
        :label="$t('mobileNumber')"
        :options="countries"
        class="lg:w-1/2 flex-col px-2 w-full"
        direction="flex-col"
        defaultValue="00971"
        @on-selection="(phone) => handleChange(phone)"
      ></ComboText>
    </Field>
    <Field
      v-if="props.isShowFingerprintCheckbox"
      :value="true"
      name="requireEnrollmentInd"
      type="checkbox"
      v-slot="{ field }"
      class="w-full"
    >
      <label class="flex flex-row items-center lg:w-1/2 px-2 w-full gap-2">
        <input class="accent-primary" type="checkbox" v-bind="field" />
        {{ $t('requestWaitingAppointment') }}
      </label>
    </Field>
    <!-- Just for make datepicker aligment -->
    <div class="w-full"  v-if="!props.isShowFingerprintCheckbox"></div>

    <Field :rules="isRequired" name="startDate" v-slot="{ field, errors: errs, handleChange }">
      <SimpleDatepicker
        :field="field"
        :errors="errs"
        :label="i18n.t('fromDate')"
        :max-date="startMaxDateRef"
        class="lg:w-1/2 flex-col px-2 w-full"
        :defaultValue="field.value"
        @on-change="(date) => handleChange(date)"
        :serverDateFormat="'yyyy/MM/dd'"
      >
      </SimpleDatepicker>
    </Field>

    <Field :rules="isRequired" name="endDate" v-slot="{ field, errors: errs, handleChange }">
      <SimpleDatepicker
        :field="field"
        :errors="errs"
        :label="i18n.t('toDate')"
        :min-date="endMinDateRef"
        class="lg:w-1/2 flex-col px-2 w-full"
        :defaultValue="props.initialValues.endDate"
        @on-change="(date) => handleChange(date)"
        :serverDateFormat="'yyyy/MM/dd'"
      >
      </SimpleDatepicker>
    </Field>
  </div>
</template>
<script setup>
import { defineProps, ref, onBeforeMount, computed } from 'vue'
import { Field } from 'vee-validate'
import { useI18n } from 'vue-i18n'
import { DateTime } from 'luxon'
import { useLookupsStore } from '@/stores/lookups'

import SimpleDatepicker from '@/components/SimpleForm/Datepicker.vue'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import ComboText from '@/components/SimpleForm/ComboText.vue'

const lookupsStore = useLookupsStore()

const i18n = useI18n({
  messages: {
    en: {
      fromDate: 'From',
      toDate: 'To'
    },
    ar: {
      fromDate: 'من',
      toDate: 'الى'
    }
  }
})

const props = defineProps({
  initialValues: Object,
  isShowFingerprintCheckbox: {
    type: Boolean,
    default: false
  },
  roleType: String,
  values: {
    type: Object,
    default: () => ({})
  }
})
const countries = ref([])

const validateEmail = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (value && !emailRegex.test(value)) {
    return i18n.t('INVALID_EMAIL')
  }

  return true
}

function isRequired(value) {
  if (value && `${value}`.trim()) {
    return true
  }

  return 'INVALID_REQUIRED'
}
const formateDate = (currentDate) => {
  return DateTime.fromFormat(currentDate, 'yyyy/MM/dd').toFormat('dd/MM/yyyy')
}

const startMaxDateRef = computed(() => {
  if (props.values.endDate) {
    return formateDate(props.values.endDate)
  } else {
    return DateTime.now().toFormat('dd/MM/yyyy')
  }
})

const endMinDateRef = computed(() => {
  if (props.values.startDate) {
    return formateDate(props.values.startDate)
  }
  return ''
})

onBeforeMount(async () => {
  countries.value = await lookupsStore.fetchLookup('/api/lookup/countries')
})
</script>

<style></style>
